<div class="topbar" style="border-bottom: 1px solid #e0e0e0;" [ngClass]="{ 'theme-dark': isDarkMode() }">
    <div class="search-section">
        <mat-form-field class="search-bar" appearance="outline">
            <mat-label>Search Services...</mat-label>
            <input matInput [(ngModel)]="searchTerm" (input)="inputTabSearch()" />
            <mat-icon matSuffix class="close-icon" *ngIf="searchTerm" (click)="clearTabSearch()">close</mat-icon>
        </mat-form-field>
    </div>
    <button mat-raised-button color="primary" class="add-button" (click)="openAddServiceDialog()">
        Add Services
    </button>
</div>
<div class="tariff-services-container">
    <!-- Sidebar: Services -->
    <!-- <div class="show-Services">
        <div class="tab-container" #tabsRef>
            <mat-tab-group [selectedIndex]="selectedTabIndex" mat-stretch-tabs="false" class="vertical-tab-group"
                (selectedIndexChange)="onTabChange($event)">
                <mat-tab *ngFor=" let tab of tabs; let i=index">
                    <ng-template mat-tab-label>
                        <div class="tab-label" [ngClass]="{ 'active-tab': selectedTabIndex === i }">
                            <span [ngClass]="{ 'active-label': selectedTabIndex === i }" class="mat-tab-label">
                                {{tab}}
                            </span>
                        </div>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div> -->
    <div class="sidebar-panel">
        <div class="service-item" *ngFor="let tab of tabs; let i = index" [class.active]="selectedTabIndex === i"
            (click)="onTabChange(i)">
            {{ tab }}
        </div>
    </div>
    <!-- Table  -->
    <div class="show-table">
        <div class="topbar" [ngClass]="{ 'theme-dark': isDarkMode() }">
            <div class="search-section">
                <mat-form-field class="search-bar" appearance="outline">
                    <mat-label>Search</mat-label>
                    <input matInput [(ngModel)]="tableSearchTerm" (input)="inputTableSearch()" />
                    <mat-icon matSuffix class="close-icon" *ngIf="tableSearchTerm"
                        (click)="clearSearch()">close</mat-icon>
                </mat-form-field>
            </div>

            <button mat-raised-button color="primary" class="add-button" (click)="openAddTabDialog(null)">
                Add {{selectedTabName}}
            </button>
        </div>

        <!-- Table section -->
        <div *ngIf="dataSource?.data as data">
            <ng-container *ngIf="data.length > 0; else noData">
                <div class="table-container-data">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" [ngClass]="{ 'dark-table': isDarkMode() }">

                        <!-- SNO -->
                        <ng-container matColumnDef="Sl.No">
                            <th mat-header-cell *matHeaderCellDef> SNO </th>
                            <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
                        </ng-container>

                        <!-- Dynamic Field Columns -->
                        <ng-container *ngFor="let field of dynamicColumns" [matColumnDef]="field">
                            <th mat-header-cell *matHeaderCellDef> {{field}} </th>
                            <td mat-cell *matCellDef="let element"> {{ element[fieldKeyResolver(field)] }} </td>
                        </ng-container>

                        <!-- Action -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>Action</th>
                            <td mat-cell *matCellDef="let element">
                                <button class="edit-icon-button" mat-icon-button (click)="openAddTabDialog(element)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </ng-container>
        </div>
        <ng-template #noData>
            <div class="no-data-text">
                No data found.
            </div>
        </ng-template>
    </div>
</div>
